module.exports = __webpack_public_path__ + "static/media/fa-brands-400.a9c4bb73.svg";